import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/modules/auth/services/auth.service';

@Component({
  selector: 'app-public-message',
  templateUrl: './public-message.component.html',
  styleUrls: ['./public-message.component.scss']
})
export class PublicMessageComponent implements OnInit {

  isAlertClosed = true;

  constructor(private authService : AuthService) { }

  ngOnInit() {
   // this.authService.confirmEamil();
   // this.authService.resendConfirmationURL("suresh@drbeen.com");
  }


  /**
   * Close public alert shown to user
   */
  closeAlert() : void {
      this.isAlertClosed = true;
  }


}
